export const small = '@media (min-width: 720px)'
export const medium = '@media (min-width: 1280px)'
export const large = '@media (min-width: 1920px)'

export const theme = {
    mq: {
        small,
        medium,
        large,
    }
}
// Other variants:

// sm, small: 600px
// md, medium: 960px
// lg, large: 1280px
// xl, extra-large: 1920px

// tablet: 640,
// laptop: 1024,
// desktop: 1280,